// Repairs a broken link pattern the model sometimes produces: percent-encoding
// the ENTIRE href (scheme included), e.g.
//   href="https%3A%2F%2Fwww.viator.com%2F...%3Ftext%3DShinjuku%2C+tokyo"
// Because that value has no real scheme, the browser treats it as relative and
// resolves it against the current page — /show/tokyo/https%3A%2F%2F...  — a dead
// link. We detect an href whose scheme is encoded (https%3A / http%3A) and
// decode it back to a proper absolute URL. Correct links (literal https://…)
// are left untouched, so this is safe to run on every itinerary.
export function fixEncodedLinks(html: string): string {
  if (!html) return html;
  return html.replace(
    /href=(["'])(https?%3[aA][^"']*)\1/g,
    (match, quote, encoded) => {
      try {
        return `href=${quote}${decodeURIComponent(encoded)}${quote}`;
      } catch {
        return match;
      }
    }
  );
}
